<template>
    <div id="app">

      <div style="width: 80%; height: 100%; float: left;">
        <div v-if="showStatSection == 1" style="width: 100%; height: 100%;">

        <div style="width: 100%; height: 35%; padding-left: 0.5%; padding-right: 0.5%; padding-top: 1%;">
        <v-card style="width: 100%; height: 100%">
          <div style="width: 100%; height: 20%;  font-size: 1vw; font-weight: bold;   color: rgba(0,0,0,0.4);">
            <div style="width: 80%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; padding-left: 20%">
              <v-fade-transition>
              <div v-if="changeTitle" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                Last 12 Month Comparison {{regionSwitchTitle}}
              </div>
              </v-fade-transition>
            </div>
            <div style="width: 20%; height: 100%; float: left; display: flex; justify-content: center; align-items: center;">
            <v-switch v-model="switchState" style="transform: scale(0.8)" inset color="gray"></v-switch>
            </div>


          </div>

          <div style="width: 100%; height: 80%; display: flex; justify-content: center; align-items: center ">

            <apexcharts style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center " v-if="showChart" type=bar width="90%" height="100%" :options="chartOptions" :series="series" />

          </div>
        </v-card>




        </div>


        <div style="width: 100%; height: 65%; padding-left: 0.5%; padding-right: 0.5%; padding-top: 0.5%; padding-bottom: 1%">

        <v-card style="width: 100%; height: 100%">

          <div class="large-donut">
            <div style="width: 100%; height: 10%; display: flex; justify-content: center; align-items: center;  font-size: 1vw; font-weight: bold;   color: rgba(0,0,0,0.4);">

              Total Distribution

            </div>
            <apexcharts class="donut" v-if="showChart" :type="type" width="100%" height="75%" :options="pieOptions" :series="pieChartData" />
          </div>

          <div class="total-area">
            <div style="height: 10%; font-weight: bold; width: 100%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.4); font-size: 1vw;">Per Chat</div>
            <div class="each-chat-summary">
              <div class="chat-divider">
                <div class="chat-color-blip-area">
                  <v-icon style="font-size: 3vh" color="#ff6e49">fas fa-circle</v-icon>
                </div>
                <div class="chat-name-area">
                  UK
                </div>
                <div class="chat-gen-divider">
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Revenue
                    </div>
                    <div class="gen-section-data">
                      £{{ukRevenueTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Payments
                    </div>
                    <div class="gen-section-data">
                      {{ukTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Daily
                    </div>
                    <div class="gen-section-data">
                      £{{ukDailyRevenueTotal}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="chat-divider">
                <div class="chat-color-blip-area">
                  <v-icon style="font-size: 3vh" color="#fabe3f">fas fa-circle</v-icon>
                </div>
                <div class="chat-name-area">
                  Australia
                </div>
                <div class="chat-gen-divider">
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Revenue
                    </div>
                    <div class="gen-section-data">
                      £{{australiaRevenueTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Payments
                    </div>
                    <div class="gen-section-data">
                      {{australiaTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Daily
                    </div>
                    <div class="gen-section-data">
                      £{{australiaDailyRevenueTotal}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="chat-divider">
                <div class="chat-color-blip-area">
                  <v-icon style="font-size: 3vh" color="#529ca7">fas fa-circle</v-icon>
                </div>
                <div class="chat-name-area">
                  Adult
                </div>
                <div class="chat-gen-divider">
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Revenue
                    </div>
                    <div class="gen-section-data">
                      £{{adultRevenueTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Payments
                    </div>
                    <div class="gen-section-data">
                      {{adultTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Daily
                    </div>
                    <div class="gen-section-data">
                      £{{adultDailyRevenueTotal}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style="height: 10%; font-weight: bold; width: 100%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.4); font-size: 1vw;">Per Region</div>

            <div class="total-area-nations">

              <div class="nations-divider">
                <div class="chat-color-blip-area">
                  <flag style="font-size: 3vh; border-radius: 50%" iso="gb" />
                </div>
                <div class="chat-name-area">
                  UK
                </div>
                <div class="chat-gen-divider">
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Revenue
                    </div>
                    <div class="gen-section-data">
                      £{{ukTotalRevenue}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Payments
                    </div>
                    <div class="gen-section-data">
                      {{ukTotalPayments}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Daily
                    </div>
                    <div class="gen-section-data">
                      £{{ukTotalAverageDaily}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="nations-divider">
                <div class="chat-color-blip-area">
                  <flag style="font-size: 3vh; border-radius: 50%" iso="au" />
                </div>
                <div class="chat-name-area">
                  Australia
                </div>
                <div class="chat-gen-divider">
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Revenue
                    </div>
                    <div class="gen-section-data">
                      £{{australiaRevenueTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Payments
                    </div>
                    <div class="gen-section-data">
                      {{australiaTotal}}
                    </div>
                  </div>
                  <div class="gen-section">
                    <div class="gen-section-title">
                      Daily
                    </div>
                    <div class="gen-section-data">
                      £{{australiaDailyRevenueTotal}}
                    </div>
                  </div>
                </div>
              </div>


            </div>


          </div>


        </v-card>

        </div>


        </div>



        <v-card flat v-if="showStatSection == 2" style="width: 100%; height: 100%; background: orange">
          <app-monthly-main style="width: 100%; height: 100%"></app-monthly-main>
        </v-card>



        <v-card flat v-if="showStatSection == 3" style="width: 100%; height: 100%; background: orange">
          <app-daily-main style="width: 100%; height: 100%"></app-daily-main>
        </v-card>



        <v-card flat v-if="showStatSection == 4" style="width: 100%; height: 100%; background: orange">
          <app-weekly-main style="width: 100%; height: 100%"></app-weekly-main>
        </v-card>


        <v-card flat v-if="showStatSection == 5" style="width: 100%; height: 100%; background: orange">
          <app-calendar-main style="width: 100%; height: 100%"></app-calendar-main>
        </v-card>
          


      </div>


      <div style="width: 20%; height: 100%; float: left;">


        <div style="width: 100%; height: 33.33%;">


          <div style="width: 100%; height: 25%; padding-right: 1%; padding-top: 3.5%; padding-bottom: 2%">

            <v-card style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 1vw" :color="processColor">

                  <div>
                    <v-icon color="white" style="padding-right: 5%; font-size: 1vw">fas fa-stopwatch</v-icon>
                  </div>

              <div style="width: 30%; height: 100%; display: flex; justify-content: center; align-items: center">
                {{computedAverageResponseTime(averageResponseTime)}} {{timeProcessedAverage}}
              </div>

              <div style="width: 5%; height: 100%;">


                <div v-if="moveDirection == 0" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                  <v-scroll-y-transition>
                  <v-icon style="font-size: 1vw; padding-left: 5%" v-if="moveArrows" color="white">fas fa-angle-double-down</v-icon>
                  </v-scroll-y-transition>
                </div>

                <div v-if="moveDirection == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                  <v-scroll-y-reverse-transition>
                    <v-icon style="font-size: 1vw; padding-left: 5%" v-if="moveArrows" color="white">lens</v-icon>
                  </v-scroll-y-reverse-transition>
                </div>

                <div v-if="moveDirection == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                  <v-fade-transition>
                    <v-icon style="font-size: 1vw; padding-left: 5%" v-if="moveArrows" color="white">fas fa-angle-double-up</v-icon>
                  </v-fade-transition>
                </div>



                <v-scroll-y-transition>

                </v-scroll-y-transition>





              </div>











            </v-card>

          </div>


          <div style="width: 100%; height: 75%">


            <div style="height: 33.33%; width: 50%; float: left; display: flex; justify-content: center; align-items: center; padding-right: 1%">

              <v-btn @click="openStatsView(3)" style="width: 100%; height: 90%; font-size: 1vw;" dark color="#2e2e2e"><v-icon style="padding-right: 10%; font-size: 1vw">fas fa-calendar-day</v-icon>  Daily</v-btn>

            </div>


            <div style="height: 33.33%; width: 50%; float: left; display: flex; justify-content: center; align-items: center; padding-right: 1%; padding-left: 1%">

              <v-btn @click="openStatsView(4)" style="width: 100%; height: 90%; font-size: 1vw;" dark color="#2e2e2e"><v-icon style="padding-right: 10%; font-size: 1vw">fas fa-calendar-week</v-icon>  Weekly</v-btn>

            </div>


            <div style="height: 33.33%; width: 50%; float: left; display: flex; justify-content: center; align-items: center;  padding-right: 1%">

              <v-btn @click="openStatsView(2)" style="width: 100%; height: 90%; font-size: 1vw;" dark color="#2e2e2e"><v-icon style="padding-right: 10%; font-size: 1vw">fas fa-calendar-alt</v-icon>  Monthly</v-btn>

            </div>

            <div style="height: 33.33%; width: 50%; float: left; display: flex; justify-content: center; align-items: center; padding-right: 1%; padding-left: 1%">

              <v-btn disabled style="width: 100%; height: 90%; font-size: 1vw;" light color="#2e2e2e"><v-icon style="padding-right: 10%; font-size: 1vw">fas fa-lock</v-icon>  Promo</v-btn>

            </div>

            <div style="height: 33.33%; width: 50%; float: left; display: flex; justify-content: center; align-items: center; padding-right: 1%;">

              <v-btn @click="openStatsView(1)" style="width: 100%; height: 90%; font-size: 1vw;" dark color="#2e2e2e"><v-icon style="padding-right: 10%; font-size: 1vw">fas fa-chart-bar</v-icon>  General</v-btn>

            </div>

            <div style="height: 33.33%; width: 50%; float: left; display: flex; justify-content: center; align-items: center; padding-right: 1%; padding-left: 1%">

              <v-btn @click="openStatsView(5)" style="width: 100%; height: 90%; font-size: 1vw;" dark color="#2e2e2e"><v-icon style="padding-right: 10%; font-size: 1vw">fas fa-calendar</v-icon>Calendar</v-btn>

            </div>




          </div>




        </div>


        <div style="width: 100%; height: 66.66%">

          <div style="height: 100%; width: 100%;">
            <div style="width: 100%; height: 40%;">

              <div style="width: 50%; height: 100%; float: left; padding-top: 1%; padding-bottom: 1%; padding-right: 1%;">

                <v-card style="width: 100%; height: 100%">

                  <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center">
                    <v-icon color="#2e2e2e" style="font-size: 3.5vw">fas fa-child</v-icon>
                  </div>

                  <div style="width: 100%; height: 25%; font-size: 1vw; font-weight: bold; color: #2e2e2e; display: flex; justify-content: center; align-items: center">
                    One Time Users
                  </div>

                  <div style="width: 100%; height: 45%; font-size: 4vw; font-weight: bold; color: #2e2e2e; display: flex; justify-content: center; align-items: center">
                    {{totalOneTimeCustomers}}
                  </div>

                </v-card>

              </div>

              <div style="width: 50%; height: 100%; float: left; padding-top: 1%; padding-bottom: 1%; padding-right: 2%; padding-left: 1%">

                <v-card style="width: 100%; height: 100%">
                  <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center">
                    <v-icon color="#2e2e2e" style="font-size: 3.5vw">fas fa-users</v-icon>
                  </div>

                  <div style="width: 100%; height: 25%; font-size: 1vw; font-weight: bold; color: #2e2e2e; display: flex; justify-content: center; align-items: center">
                    Returning Users
                  </div>

                  <div style="width: 100%; height: 45%; font-size: 4vw; font-weight: bold; color: #2e2e2e; display: flex; justify-content: center; align-items: center">
                    {{computedNumberOfRegularUsers}}
                  </div>
                </v-card>
              </div>
            </div>

            <div style="width: 100%; height: 60%; padding-top: 1%; padding-bottom: 4%; padding-right: 2%">
              <v-card style="width: 100%; height: 100%">

                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-size: 1vw; font-weight: bold;   color: rgba(0,0,0,0.4);">
                  Transactions Per Week Day
                </div>

                <div style="width: 100%; height: 85%; display: flex; justify-content: center; align-items: center">
                  <apexcharts style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center" v-if="showWeeklyStats" type="bar" width="90%" height="100%" :options="weeklyChartOptions" :series="weeklySeries"></apexcharts>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>



<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'
import VueApexCharts from 'vue-apexcharts'
import FlagIcon from 'vue-flag-icon'
import monthlyMain from '@/components/stats/monthly/monthly-main.vue'
import dailyMain from '@/components/stats/daily/daily-main.vue'
import weeklyMain from '@/components/stats/weekly/weekly-main.vue'
import calendarMain from '@/components/stats/calendar/calendar-main.vue'

Vue.use(FlagIcon);


Vue.use(Vuetify)
Vue.use(VueApexCharts)
export default {

  components: {
    apexcharts: VueApexCharts,
    appMonthlyMain: monthlyMain,
    appDailyMain: dailyMain,
    appWeeklyMain: weeklyMain,
    appCalendarMain: calendarMain,
  },

  props: [
    'statsOpen', 'statsUpdate'
  ],

  data () {
    return {

      showStatSection: 1,

      moveArrows: true,

      averageResponseTime:'',
      compareResponseTime:'',

      changeTitle: false,

      ausResponsOrginal: [],
      ausResponsOther: [],

      regionSwitchTitle:'UK',
      switchState: false,

      totalOneTimeCustomers: '',

      showWeeklyStats: false,

      weekdaySunday:"",
      weekdayMonday:"",
      weekdayTuesday:"",
      weekdayWednesday:"",
      weekdayThursday:"",
      weekdayFriday:"",
      weekdaySaturday:"",

      weeklySeries: [{
        name: 'Average Of',
        data: []
      }],
      weeklyChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          color: 'red',
          toolbar: {
            show: false
          }
        },
        colors: ['#47a753'],
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['Monday', 'Tuesday', 'Wednesday', 'Thursday','Friday','Saturday','Sunday',
          ],
        }
      },




      monthRevenueUk: 0,
      month1AgoRevenueUk: 0,
      month2AgoRevenueUk: 0,
      month3AgoRevenueUk: 0,
      month4AgoRevenueUk: 0,
      month5AgoRevenueUk: 0,
      month6AgoRevenueUk: 0,
      month7AgoRevenueUk: 0,
      month8AgoRevenueUk: 0,
      month9AgoRevenueUk: 0,
      month10AgoRevenueUk: 0,
      month11AgoRevenueUk: 0,

      monthRevenueAdult: '',
      month1AgoRevenueAdult: '',
      month2AgoRevenueAdult: '',
      month3AgoRevenueAdult: '',
      month4AgoRevenueAdult: '',
      month5AgoRevenueAdult: '',
      month6AgoRevenueAdult: '',
      month7AgoRevenueAdult: '',
      month8AgoRevenueAdult: '',
      month9AgoRevenueAdult: '',
      month10AgoRevenueAdult: '',
      month11AgoRevenueAdult: '',

      monthRevenueAus: 0,
      month1AgoRevenueAus: 0,
      month2AgoRevenueAus: 0,
      month3AgoRevenueAus: 0,
      month4AgoRevenueAus: 0,
      month5AgoRevenueAus: 0,
      month6AgoRevenueAus: 0,
      month7AgoRevenueAus: 0,
      month8AgoRevenueAus: 0,
      month9AgoRevenueAus: 0,
      month10AgoRevenueAus: 0,
      month11AgoRevenueAus: 0,


      //Chart S
      series: [{
        name: 'Total Of',
        data: []
      }],

      seriesAus: [{
        name: 'Total Of',
        data: []
      }],
      chartOptions: {

        chart: {
          height: 550,
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top' // top, center, bottom
            },

          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',

            fontFamily: 'Avenir, Helvetica, Arial',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [],
          position: 'top',
          labels: {
            offsetY: -20

          },
          crosshairs: {

            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 33],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      },

      //Chart E





      ukTotalPayments:'',
      ukTotalRevenue:'',
      ukTotalAverageDaily:'',


      ukDailyRevenueTotal:'',
      adultDailyRevenueTotal:'',
      australiaDailyRevenueTotal:'',


      ukRevenueTotalStat: '',
      adultRevenueTotalStat: '',

      ukRevenueTotal:'',
      adultRevenueTotal:'',
      australiaRevenueTotal:'',








      showChart: false,

      australiaTotal: '',
      ukTotal: '',
      adultTotal: '',

//Donut S
      type: 'donut',
      pieChartData: [],
      pieOptions: {

        legend: {
          show: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'top',
          horizontalAlign: 'center',
          fontSize: '15px',
          fontFamily: 'Avenir, Helvetica, Arial',
          tooltipHoverFormatter: undefined,
          labels: {
            colors: undefined,
            useSeriesColors: false
          },
          itemMargin: {
            horizontal: 10,
            vertical: 10
          },
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: true
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'top',
          style: {
            fontSize: '1.5vh',
            fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
          }
        },
        labels: ['UK', 'Australia', 'Adult'],
        // colors: ['#529ca7', '#fabe3f', '#ff6e49'],
        colors: ['#ff6e49', '#fabe3f', '#529ca7'],
        responsive: [{
          breakpoint: 800,
          options: {
            legend: {
              position: 'top'
            }

          }
        }]
      },
      //Donut E
      processColor:'',
      moveDirection:"",
    }
  },
  watch: {

    'averageResponseTime': function () {
      if (this.averageResponseTime >= 60) {
        this.processColor = '#FF6E49'
      } else if (this.averageResponseTime <= 20) {
        this.processColor = 'green'
      } else if (this.averageResponseTime > 20 && this.averageResponseTime < 60) {
        this.processColor = 'orange'
      }
    },

    'switchState': function (v) {
      this.changeRegionStat();
    }

  },


  created: function () {
    this.series[0].name = "Total Of"
    this.seriesAus[0].name = "Total Of"
    document.title = 'Chattube - Stats'
    this.getInfoOnLoad()
    setTimeout(() => this.changeTitle = true, 1000)
    setTimeout(() => this.updatePieChart(), 300)
    setInterval(this.arrowAnimation, 5000)
  },
  computed: {

    computedNumberOfRegularUsers: function () {
      var regularCustomers = this.totalNumberCustomers - this.totalOneTimeCustomers

      return regularCustomers
    },


  },
  methods: {

    openStatsView(i) {

      if (i == 1){
        this.showStatSection = 1
        this.series[0].name = "Total Of"
        this.seriesAus[0].name = "Total Of"
      }
      else if (i == 2){
        this.showStatSection = 2
      }

      else if (i == 3){
        this.showStatSection = 3
      }

      else if (i == 4){
        this.showStatSection = 4
      }

      else if (i == 5){
        this.showStatSection = 5
      }



      //Daily
      //Weekly
      //Monhtly
      //General
      //Calander




    },

    arrowAnimation () {
      this.moveArrows = !this.moveArrows

      if (this.moveArrows == false) {
        setTimeout(() => this.moveArrows = true, 1000)
      }
    },


    computedAverageResponseTime (time) {
      if (time == null) {
        this.timeProcessedAverage = 'N/A'
      }
      else if (time >= 1440){
        this.timeProcessedAverage = '+ 1 Day'
      }

      else if (time >= 120) {
        var hoursPassed = Math.floor(time / 60)

        this.timeProcessedAverage = '+ ' + hoursPassed + ' Hours'
      } else if (time >= 60) {
        var hoursPassed = Math.floor(time / 60)

        this.timeProcessedAverage = '+ ' + hoursPassed + ' Hour'
      } else if (time == 0) {
        this.timeProcessedAverage = '- 1 Minute'
      } else if (time == 1) {
        this.timeProcessedAverage = time + ' Min'
      } else if (time < 60) {
        this.timeProcessedAverage = time + ' Min'
      }
    },

    getAverageResponseTime () {
      AXIOS({
        method: 'GET',
        url: '/api/orders/stats/processTime',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session'),
          'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        this.averageResponseTime = response.data
        this.averageResponseTime = this.averageResponseTime.toFixed(0)
      })
    },


    getCompareResponseTime () {
      AXIOS({
        method: 'GET',
        url: '/api/orders/stats/compareTime',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session'),
          'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        this.compareResponseTime = response.data

        if (this.compareResponseTime == this.averageResponseTimeUnfiltered) {
          this.moveDirection = 1 // Staying the Same
        } else if (this.compareResponseTime < this.averageResponseTimeUnfiltered) {
          this.moveDirection = 2 // Going Up
        } else if (this.compareResponseTime > this.averageResponseTimeUnfiltered) {
          this.moveDirection = 0 // Going Down
        }
      })
    },



    getAusMonthlyData(){
      AXIOS({
        method: 'GET',
        url: '/api/orders/stats/monthlyRevenue/aus',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session'),
          'Access-Control-Allow-Origin': '*'
        }
      }).then(monthyAusResponse => {

        if (monthyAusResponse.data[0][0] != new Date().getMonth() + 1){
          monthyAusResponse.data.unshift([new Date().getMonth() + 1,new Date(new Date().setDate(1)).toISOString(),0])
        }
        this.monthyAusResponseChart = monthyAusResponse

        if (this.monthyAusResponseChart.data[0][0] != new Date().getMonth() + 1){
          this.monthyAusResponseChart.data.unshift([new Date().getMonth() + 1,new Date(new Date().setDate(1)).toISOString(),0])
        }
        this.monthsPerYear = 12
        this.monthsWithNoDateAus = this.monthsPerYear - this.monthyAusResponseChart.data.length

        var i = 0;
        while (i < this.monthyAusResponseChart.data.length) {
          this.seriesAus[0].data.push(this.monthyAusResponseChart.data[i][2])
          i++;
        }
        var o = 0;
        while (o < this.monthsWithNoDateAus) {
          this.seriesAus[0].data.push(0)
          o++;
        }
        this.seriesAus[0].data.reverse()

        this.monthRevenueAus = this.seriesAus[0].data[11]
        this.month1AgoRevenueAus = this.seriesAus[0].data[10]
        this.month2AgoRevenueAus = this.seriesAus[0].data[9]
        this.month3AgoRevenueAus = this.seriesAus[0].data[8]
        this.month4AgoRevenueAus = this.seriesAus[0].data[7]
        this.month5AgoRevenueAus = this.seriesAus[0].data[6]
        this.month6AgoRevenueAus = this.seriesAus[0].data[5]
        this.month7AgoRevenueAus = this.seriesAus[0].data[4]
        this.month8AgoRevenueAus = this.seriesAus[0].data[3]
        this.month9AgoRevenueAus = this.seriesAus[0].data[2]
        this.month10AgoRevenueAus = this.seriesAus[0].data[1]
        this.month11AgoRevenueAus = this.seriesAus[0].data[0]
      })
    },


    getUkMonthlyData(){
      AXIOS({
        method: 'GET',
        url: '/api/orders/stats/monthlyRevenue/uk',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session'),
          'Access-Control-Allow-Origin': '*'
        }
      }).then(monthyUkResponse => {

        this.monthyUkResponseChart = monthyUkResponse

        if (this.monthyUkResponseChart.data[0][0] != new Date().getMonth() + 1){
          this.monthyUkResponseChart.data.unshift([new Date().getMonth() + 1,new Date(new Date().setDate(1)).toISOString(),0])
        }
        this.monthsPerYear = 12
        this.monthsWithNoDate = this.monthsPerYear - this.monthyUkResponseChart.data.length

        var i = 0;
        while (i < this.monthyUkResponseChart.data.length) {
          this.series[0].data.push(this.monthyUkResponseChart.data[i][2])
          i++;
        }
        var o = 0;
        while (o < this.monthsWithNoDate) {
          this.series[0].data.push(0)
          o++;
        }
        this.series[0].data.reverse()



        this.monthRevenueUk = this.series[0].data[11]
        this.month1AgoRevenueUk = this.series[0].data[10]
        this.month2AgoRevenueUk = this.series[0].data[9]
        this.month3AgoRevenueUk = this.series[0].data[8]
        this.month4AgoRevenueUk = this.series[0].data[7]
        this.month5AgoRevenueUk = this.series[0].data[6]
        this.month6AgoRevenueUk = this.series[0].data[5]
        this.month7AgoRevenueUk = this.series[0].data[4]
        this.month8AgoRevenueUk = this.series[0].data[3]
        this.month9AgoRevenueUk = this.series[0].data[2]
        this.month10AgoRevenueUk = this.series[0].data[1]
        this.month11AgoRevenueUk = this.series[0].data[0]

        setTimeout(() => this.showChart = false, 300)
        setTimeout(() => this.showChart = true, 500)
      })
    },


    regionAusUpdateChart() {

      this.series[0].data.map(() => {
        return
      })
      // In the same way, update the series option
      this.series = [{
        data: [
          this.month11AgoRevenueAus,
          this.month10AgoRevenueAus,
          this.month9AgoRevenueAus,
          this.month8AgoRevenueAus,
          this.month7AgoRevenueAus,
          this.month6AgoRevenueAus,
          this.month5AgoRevenueAus,
          this.month4AgoRevenueAus,
          this.month3AgoRevenueAus,
          this.month2AgoRevenueAus,
          this.month1AgoRevenueAus,
          this.monthRevenueAus
        ]
      }]
    },

    regionUkUpdateChart() {
      this.series[0].data.map(() => {
        return
      })
      // In the same way, update the series option
      this.series = [{
        data: [
          this.month11AgoRevenueUk,
          this.month10AgoRevenueUk,
          this.month9AgoRevenueUk,
          this.month8AgoRevenueUk,
          this.month7AgoRevenueUk,
          this.month6AgoRevenueUk,
          this.month5AgoRevenueUk,
          this.month4AgoRevenueUk,
          this.month3AgoRevenueUk,
          this.month2AgoRevenueUk,
          this.month1AgoRevenueUk,
          this.monthRevenueUk
        ]
      }]
    },




    changeRegionStat(){
      this.changeTitle = false

      if (this.switchState == false){
        this.regionSwitchTitle = "UK"

        this.regionUkUpdateChart()
        setTimeout(() => this.changeTitle = true, 250)
      }
      else if (this.switchState == true){
        this.regionSwitchTitle = "Australia"
        this.regionAusUpdateChart()
        setTimeout(() => this.changeTitle = true, 250)
      }

    },



    getTotalAmountOfCustomers () {
      AXIOS({
        method: 'GET',
        url: '/api/orders/stats/customers/unique',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session'),
          'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        this.totalNumberCustomers = response.data

      })
    },

    getOneTimeCustomers () {
      AXIOS({
        method: 'GET',
        url: '/api/orders/stats/customers/onetime',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session'),
          'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        this.totalOneTimeCustomers = response.data
      })
    },


    getWeekDayStats() {
      Promise.all([
        AXIOS.get('/api/orders/stats/orders/perday/0', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/orders/perday/1', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/orders/perday/2', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/orders/perday/3', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/orders/perday/4', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/orders/perday/5', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/orders/perday/6', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
      ])
        .then(((response) => {
          this.weekdaySunday = response[0].data
          this.weekdayMonday = response[1].data
          this.weekdayTuesday = response[2].data
          this.weekdayWednesday = response[3].data
          this.weekdayThursday = response[4].data
          this.weekdayFriday = response[5].data
          this.weekdaySaturday = response[6].data
          setTimeout(() => this.updateChart(), 300)
        }));
    },

    updateChart(){
      this.weeklySeries[0].data = [ parseFloat(this.weekdayMonday).toFixed(2), parseFloat(this.weekdayTuesday).toFixed(2),parseFloat(this.weekdayWednesday).toFixed(2),parseFloat(this.weekdayThursday).toFixed(2),parseFloat(this.weekdayFriday).toFixed(2),parseFloat(this.weekdaySaturday).toFixed(2),parseFloat(this.weekdaySunday).toFixed(2)]
      setTimeout(() => this.showWeeklyStats = false, 300)
      setTimeout(() => this.showWeeklyStats = true, 500)
    },




    getInfoOnLoad () {
      this.getTotalAmountOfCustomers()
      this.getPayment()
      this.getRevenue()
      this.getDailyRevenue()
      this.getUKRegionStats()
      this.getAusMonthlyData()
      this.getUkMonthlyData()
      this.getAverageResponseTime()
      this.getWeekDayStats()
      this.getOneTimeCustomers()




      this.getLast6Months()
       this.chartOptions.xaxis.categories.push(this.month11AgoName.substr(0, 3),this.month10AgoName.substr(0, 3),this.month9AgoName.substr(0, 3),this.month8AgoName.substr(0, 3),this.month7AgoName.substr(0, 3), this.month6AgoName.substr(0, 3), this.month5AgoName.substr(0, 3), this.month4AgoName.substr(0, 3), this.month3AgoName.substr(0, 3), this.month2AgoName.substr(0, 3), this.month1AgoName.substr(0, 3), this.thisMonth.substr(0, 3))



    },

    updatePieChart: function () {
      this.pieChartData = [this.ukTotal, this.australiaTotal, this.adultTotal]
    },
    pushIntoChart () {
      this.pieChartData.push(this.ukTotal, this.australiaTotal, this.adultTotal)
    },


    getPayment() {
      Promise.all([
        AXIOS.get('/api/orders/stats/service/1', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/service/2', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/service/3', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}})
      ])
        .then(((paymentResponse) => {
          this.ukTotal = paymentResponse[0].data
          this.ukTotalStat = paymentResponse[0].data

          this.adultTotal = paymentResponse[1].data
          this.adultTotalStat = paymentResponse[1].data

          this.australiaTotal = paymentResponse[2].data

          setTimeout(() => this.showChart = true, 500)

        }));
    },


    getRevenue() {

      Promise.all([
        AXIOS.get('/api/orders/stats/revenue/1', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/revenue/2', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/revenue/3', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}})
      ])
        .then(((revenueResponse) => {
          this.ukRevenueTotal = revenueResponse[0].data
          this.ukRevenueTotalStat = revenueResponse[0].data
          this.ukRevenueTotal = parseFloat(this.ukRevenueTotal).toFixed(2)

          this.adultRevenueTotal = revenueResponse[1].data
          this.adultRevenueTotalStat = revenueResponse[1].data
          this.adultRevenueTotal = parseFloat(this.adultRevenueTotal).toFixed(2)

          this.australiaRevenueTotal = revenueResponse[2].data
          this.australiaRevenueTotal = parseFloat(this.australiaRevenueTotal).toFixed(2)
        }));
    },

    getDailyRevenue() {

      Promise.all([
        AXIOS.get('/api/orders/stats/dailyAverage/1', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/dailyAverage/2', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/dailyAverage/3', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
      ])
        .then(((dailyResponse) => {
          this.ukDailyRevenueTotal = dailyResponse[0].data
          this.ukDailyRevenueTotal = parseFloat(this.ukDailyRevenueTotal).toFixed(2)

          this.adultDailyRevenueTotal = dailyResponse[1].data
          this.adultDailyRevenueTotal = parseFloat(this.adultDailyRevenueTotal).toFixed(2)

          this.australiaDailyRevenueTotal = dailyResponse[2].data
          this.australiaDailyRevenueTotal = parseFloat(this.australiaDailyRevenueTotal).toFixed(2)

        }));
    },


    getUKRegionStats(){

      Promise.all([
        AXIOS.get('/api/orders/stats/payments/uk', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/revenue/uk', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
        AXIOS.get('/api/orders/stats/dailyAverage/uk', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}})
      ])
        .then(((ukStatsResponse) => {

          this.ukTotalPayments = ukStatsResponse[0].data



          this.ukTotalRevenue = ukStatsResponse[1].data

          this.ukTotalRevenue = parseFloat(this.ukTotalRevenue).toFixed(2)
          this.ukTotalAverageDaily = ukStatsResponse[2].data
          this.ukTotalAverageDaily = parseFloat(this.ukTotalAverageDaily).toFixed(2)
        }));
    },




    pushIntoChart () {
      this.pieChartData.push(this.ukTotal, this.australiaTotal, this.adultTotal)
    },

    getLast6Months () {
      this.date = new Date()
      this.thisMonth = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month1AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month2AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month3AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month4AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month5AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month6AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month7AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month8AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month9AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month10AgoName = this.date.toLocaleString('default', { month: 'long' })

      this.date.setMonth(this.date.getMonth() - 1)
      this.month11AgoName = this.date.toLocaleString('default', { month: 'long' })
    },
  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        /*padding: 1%;*/
    }


    .large-donut {
      width: 45%;
      height: 100%;
      float: left;
    }

    .donut {
      width: 100%;
      height: 90%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .total-area{

      width: 55%;
      height: 100%;
      float: left


    }

    .total-area-nations {
      width: 100%; height: 40%;
    }

    .nations-divider {
      height: 100%; width: 50%; float: left;

    }

    .each-chat-summary {
      width: 100%; height: 40%;
    }

    .chat-divider {
      width: 33.3%; height: 100%; float: left;
    }
    .chat-color-blip-area {
      height: 15%; width: 100%; display: flex; justify-content: center; align-items: center
    }

    .chat-name-area {
      height: 15%; width: 100%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.7); font-weight: bold; font-size: 2vh;
    }

    .chat-gen-divider {
      width: 100%; height: 70%
    }
    .gen-section {
      width: 100%; height: 33.3%
    }
    .gen-section-title {
      width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.7); font-size: 0.8vw
    }
    .gen-section-data {
      width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 0.9vw
    }

</style>
